export const set = (key: string, value: string) => window.sessionStorage.setItem(key, value);

export const get = (key: string, defaultValue: string | null = null): string | null =>
  window.sessionStorage.getItem(key) || defaultValue;

export const remove = (key: string): void => {
  window.sessionStorage.removeItem(key);
};
